import * as $$ from "jquery-selector-cache";

/**
 * Initialize the module
 */
export function initSendMail() {
    // Exit when component don't exist
    if (!$$("#sendMail").length) {
        return;
    }
    $("#sendMail").on("click", ".elem-button", handleSendMailFormSubmit);
}

/**
 * handleSendMailFormSubmit
 * @param evt
 */
function handleSendMailFormSubmit(evt: JQuery.TriggeredEvent<HTMLElement>) {
    evt.preventDefault();
    const form = $$("#sendMail");
    if (!validate(form)) {
        $$("#errorMsgSharePopup").show();
        return;
    } else {
        $$("#errorMsgSharePopup").hide();
    }
    const pathname = window.location.pathname;
    const path = pathname.split("/");
    const pid = path[path.length - 1];
    $.ajax(
        " /ajax/sendMail/product/" + pid + "?" + form.serialize())
        .done((response: string) => {
            if (response && response.trim().length > 0 && response === "Email sent correctly") {
                $$(".btn-close-popin").click();
            } else {
                $$("#errorMsgSharePopupResult").show();
            }
        });
}

/**
 * valid email test
 * @param mail
 */
function validEmail(mail: string) {
    const emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return emailPattern.test(mail);
}

/**
 * test form
 * @param form
 */
function validate(form: any) {
    const from: string = form.find("input[name=from]").val();
    const to: string = form.find("input[name=to]").val();
    return from !== "" && to !== "" && validEmail(from) && validEmail(to);
}
